import {HttpRequest,HttpMethod} from "./http";

class ReportProvider extends HttpRequest {


	ReportSaleChannel(params){
		return this.request(HttpMethod.Get,`/api/v2/reports/recbysalechannel`,params );
	}

	ReportProduct(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/recbyproduct`,params );
	}

	ReportUser(params){
		return this.request(HttpMethod.Get,`/api/v2/reports/recbyuser`,params );
	}

	ReportUserTeam(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/recbyteam`,params );
	}

	ReportUserAndProduct(params){
		return this.request(HttpMethod.Get,`/api/v2/reports/recbyuserproduct`,params );
	}

	ReportDashboard(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/dashboard`,params );
	}
	
	ReportSummaryWmsProduct(params){
		return this.request(HttpMethod.Get,`/api/v2/reports/summary_wms_product`,params );
	}

	ReportSummaryWmsProductAsync(params){
		return this.request(HttpMethod.Get,`/api/v2/reports/summary_wms_product_async`,params );
	}
	

	ReportCommission(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/commission`,params );
	}

	ReportSaleChannelProduct(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/salebyplatformandpromotion`,params );
	}

	ReportOrderReturn(params){
		return this.request(HttpMethod.Get,`/api/v1/reports/orderreturn`,params );
	}
}

export default ReportProvider